import { render, staticRenderFns } from "./ItemizeAlreadyWithdraw.vue?vue&type=template&id=20c7c3f0"
import script from "./ItemizeAlreadyWithdraw.vue?vue&type=script&lang=js"
export * from "./ItemizeAlreadyWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports